import { MediaWithContent } from '@/components/elements/MediaWithContent';
import Container from '@/components/global/Container';
import { TitleAndDescription } from '@/components/shared/TitleAndDescription';
import { IComponentBlocksAltContent, IEnum_Mediawithcontent_Mediaalignment } from '@/graphql/__generated__/global/types';

export const AlternatingMediaWithContentBlock = ({ titleDescription, backgroundColour, mediaWithContent }: IComponentBlocksAltContent) => {
    const mediaWithContentItems = mediaWithContent?.data ?? [];

    return (
        <Container bg={backgroundColour} rounded>
            {titleDescription && <TitleAndDescription {...titleDescription} />}
            {mediaWithContentItems.length > 0
                ? mediaWithContentItems.map(({ id, attributes }) => {
                      if (!attributes) {
                          return null;
                      }

                      return (
                          <MediaWithContent
                              key={id}
                              title={attributes.title}
                              description={attributes.description}
                              link={attributes.link}
                              image={attributes.image}
                              video={attributes.video}
                              mediaAlignment={attributes.mediaAlignment ?? ('left' as IEnum_Mediawithcontent_Mediaalignment)}
                          />
                      );
                  })
                : null}
        </Container>
    );
};

export default AlternatingMediaWithContentBlock;
